export const ON_GET_SESSIONS_DATA_REQUEST = 'ON_GET_SESSIONS_DATA_REQUEST';
export const ON_GET_SESSIONS_DATA_SUCCESS = 'ON_GET_SESSIONS_DATA_SUCCESS';
export const ON_GET_SESSIONS_DATA_FAILED = 'ON_GET_SESSIONS_DATA_FAILED';
